import classNames from 'classnames'
import { Button } from '@/atoms/Button'
import { ArrowLeftIcon } from '@/atoms/Icons/ArrowLeftIcon'
import { ArrowRightIcon } from '@/atoms/Icons/ArrowRightIcon'
import { useTranslate } from '@/utils/translate/translate-client'
import { SubmitTorchApplicationProgress } from './SubmitTorchApplicationProgress'

export type TorchApplicationSubmissionHeaderProps = {
  disabled?: boolean
  onBack?: () => void
  onNext?: () => void
}

export const TorchApplicationSubmissionHeader = ({
  disabled,
  onBack,
  onNext,
}: TorchApplicationSubmissionHeaderProps) => {
  const { t } = useTranslate('guild-create')

  return (
    <div className="flex w-full flex-row items-center justify-between px-4 lg:px-32">
      <div className="flex flex-1">
        {onBack && (
          <Button variant="plain" className="select-none font-semibold" onClick={onBack}>
            <div className="flex flex-row items-center gap-2">
              <ArrowLeftIcon color="core-gray-950" size={20} />
              <span className="hidden md:block"> {t('back', 'Back')}</span>
            </div>
          </Button>
        )}
      </div>
      <div className="flex flex-1 justify-center">
        <SubmitTorchApplicationProgress />
      </div>
      <div className="flex flex-1 select-none justify-end">
        {onNext && (
          <Button variant="plain" className="select-none font-semibold" disabled={disabled} onClick={onNext}>
            <div className={classNames('flex flex-row items-center gap-2', { 'opacity-40': disabled })}>
              <span className="hidden md:block">{t('next', 'Next')} </span>
              <ArrowRightIcon color="core-gray-950" size={20} />
            </div>
          </Button>
        )}
      </div>
    </div>
  )
}
